import { createFileRoute, Link, notFound } from "@tanstack/react-router";
import { BoomBurst } from "@/components/runboom/boom-burst";
import {
  BrandFooter,
  BrandHeader,
  Wordmark,
} from "@/components/runboom/marks";
import { boomMoments, runners } from "@/lib/mock";

export const Route = createFileRoute("/boom/$id")({
  loader: ({ params }) => {
    const moment = boomMoments[params.id];
    if (!moment) throw notFound();
    return { moment };
  },
  component: BoomPage,
});

function BoomPage() {
  const { moment } = Route.useLoaderData();
  const runner = runners[moment.runnerHandle];
  const date = new Date(moment.setAt);

  return (
    <main className="mx-auto max-w-[1280px] px-5 py-6 sm:px-8 sm:py-10">
      <BrandHeader rightTab="BOOM Verified" rightTabTone="orange" />

      <div className="mt-4 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-3">
          <Wordmark size="sm" />
        </Link>
        <nav className="flex items-center gap-3 font-mono text-[12px] uppercase tracking-[0.1em] text-fg-muted sm:gap-5">
          <Link
            to="/u/$handle"
            params={{ handle: moment.runnerHandle }}
            className="hidden hover:text-fg sm:inline"
          >
            @{moment.runnerHandle}
          </Link>
          <Link to="/wall" className="hidden hover:text-fg sm:inline">Wall</Link>
        </nav>
      </div>

      <section className="mt-6 sm:mt-8">
        <BoomBurst
          runnerName={moment.runnerName}
          runnerHandle={moment.runnerHandle}
          distanceLabel={moment.distanceLabel}
          newTimeSeconds={moment.newTimeSeconds}
          previousPbSeconds={moment.previousPbSeconds}
          raceName={moment.raceName}
          setAt={moment.setAt}
        />
      </section>

      <section className="mt-6 grid grid-cols-1 gap-3 sm:mt-8 sm:grid-cols-2">
        <Link
          to="/u/$handle"
          params={{ handle: moment.runnerHandle }}
          className="group flex items-center gap-4 rounded-[18px] border border-border bg-bg-elevated p-5 transition-colors hover:border-blood-orange"
        >
          {runner ? (
            <img
              src={runner.avatar}
              alt=""
              className="h-12 w-12 rounded-full border border-border-strong object-cover"
            />
          ) : null}
          <div className="min-w-0 flex-1">
            <div className="font-mono text-[11px] uppercase tracking-[0.12em] text-fg-subtle">
              See the profile
            </div>
            <div className="mt-0.5 font-display text-[20px] leading-[22px] tracking-[-0.01em] text-fg sm:text-[24px] sm:leading-[26px]">
              {moment.runnerName.toUpperCase()} · ALL PBs
            </div>
          </div>
          <span aria-hidden className="font-mono text-fg-muted group-hover:text-blood-orange">→</span>
        </Link>
        <div className="flex items-center gap-4 rounded-[18px] border border-border bg-bg-elevated p-5">
          <div className="font-display tabular text-[36px] leading-none tracking-[-0.015em] text-fg">
            {date.toLocaleDateString("en-GB", { day: "numeric", month: "short" })}
          </div>
          <div className="flex-1">
            <div className="font-mono text-[11px] uppercase tracking-[0.12em] text-fg-subtle">
              When
            </div>
            <div className="mt-0.5 font-mono text-[12px] uppercase tracking-[0.08em] text-fg-muted">
              {date
                .toLocaleDateString("en-GB", {
                  weekday: "long",
                  day: "numeric",
                  month: "long",
                  year: "numeric",
                })
                .toUpperCase()}
            </div>
          </div>
        </div>
      </section>

      <BrandFooter />
    </main>
  );
}
